module.exports = __webpack_public_path__ + "./images/container.f190e0.jpg";